import { render, staticRenderFns } from "./StuTestAudit.vue?vue&type=template&id=6d98a370"
import script from "./StuTestAudit.vue?vue&type=script&lang=js"
export * from "./StuTestAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports